export var Url;
(function (Url) {
    Url["Action"] = "/action";
    Url["AgentHandlingTime"] = "/reporting/average-handling-time";
    Url["AgentInformation"] = "/agent-information";
    Url["AgentsOnChat"] = "/agents-on-chat";
    Url["Attachments"] = "/attachments";
    Url["AuthMethods"] = "/auth-methods";
    Url["AutomatableEmail"] = "/automatable-email";
    Url["Bans"] = "/banned-email-addresses";
    Url["BookingDetails"] = "/booking-details";
    Url["Brands"] = "/brands";
    Url["Call"] = "/calls";
    Url["ChangeLanguage"] = "/change-language";
    Url["Chat"] = "/chats";
    Url["ChatLocation"] = "/chats/:chatId/location";
    Url["ChatDevice"] = "/chats/:chatId/device";
    Url["ChatBrowser"] = "/chats/:chatId/browser";
    Url["ChatOperatingSystem"] = "/chats/:chatId/operating-system";
    Url["ChatIPAddress"] = "/chats/:chatId/ip-address";
    Url["ChatTranscript"] = "/transcripts";
    Url["ChatWallboard"] = "/live-chat-reporting/chat-wallboard";
    Url["ChatWidgetAppearances"] = "/chat-widget-appearances";
    Url["Configuration"] = "/chat-configuration";
    Url["Conversations"] = "/conversations";
    Url["ConversationsTranscript"] = "/conversations/:conversationId/transcripts";
    Url["CustomerUrls"] = "/customer-urls";
    Url["EmailAccounts"] = "/email-accounts";
    Url["EmailRoutingRules"] = "/email-routing-rules";
    Url["Departments"] = "/departments";
    Url["Emails"] = "/emails";
    Url["EmailsAssignments"] = "/emails/:emailId/assignments";
    Url["EmailsDeferrals"] = "/deferrals";
    Url["EmailsDeferred"] = "/emails/deferred";
    Url["EmailsNext"] = "/emails/next";
    Url["EmailsProposedActions"] = "/proposed-actions";
    Url["ExternalInteractions"] = "/external-interactions";
    Url["Flow"] = "/logic/flow";
    Url["FormFields"] = "/form-fields";
    Url["FormFieldsSearch"] = "/form-fields/:formFieldId/search";
    Url["FormSubmissions"] = "/form-submissions";
    Url["Forms"] = "/forms";
    Url["Intents"] = "/intents";
    Url["Interactions"] = "/interactions";
    Url["InteractionMetricsDistributions"] = "/interaction-metrics/distribution";
    Url["InteractionVariables"] = "/interactions/:interactionDetailId/variables";
    Url["Languages"] = "/languages";
    Url["LiveChatReportingQueueLength"] = "/live-chat-reporting/queue-length";
    Url["LiveChatReportingProcessingCount"] = "/live-chat-reporting/live-processing-count";
    Url["LiveChatReportingAgentsOnline"] = "/live-chat-reporting/agents-online";
    Url["LiveChatReportingProcessedLastHour"] = "/live-chat-reporting/processed-last-hour";
    Url["LiveChatReportingLongestWaitTime"] = "/live-chat-reporting/longest-wait-time";
    Url["LiveChatReportingAverageWaitTime"] = "/live-chat-reporting/average-wait-time";
    Url["LiveChatReportingAverageChatLength"] = "/live-chat-reporting/average-chat-length";
    Url["LiveChatReportingAbandonedRate"] = "/live-chat-reporting/abandoned-rate";
    Url["LiveEmailReportingEntitySummaries"] = "/live-email-reporting/entity-summaries";
    Url["LiveEmailReportingQueueResponses"] = "/live-email-reporting/queue-responses";
    Url["LiveEmailReportingQueueLength"] = "/live-email-reporting/queue-length";
    Url["LiveEmailReportingQueueOutsideSla"] = "/live-email-reporting/queue-outside-sla";
    Url["LiveEmailReportingQueueOldestEmail"] = "/live-email-reporting/queue-oldest-email";
    Url["LiveEmailReportingProcessed"] = "/live-email-reporting/processed";
    Url["LiveEmailReportingProcessingRate"] = "/live-email-reporting/processing-rate";
    Url["LiveEmailReportingServiceLevelAgreement"] = "/live-email-reporting/service-level-agreement";
    Url["LiveEmailReportingQueueTrend"] = "/live-email-reporting/queue-trend";
    Url["LiveEmailReportingQueueMovement"] = "/live-email-reporting/queue-movement";
    Url["LiveEmailReportingQueueDistribution"] = "/live-email-reporting/queue-distribution";
    Url["ManualRoutingEmails"] = "/manual-routing-emails";
    Url["MessageBirdChannels"] = "/message-bird-channels";
    Url["Notes"] = "/notes";
    Url["OfflineDeflection"] = "/offline-deflection";
    Url["OutboundEmailActions"] = "/outbound-email-actions";
    Url["Predictions"] = "/predictions";
    Url["Query"] = "/queries";
    Url["QuerySearch"] = "/email-search";
    Url["ReportAxes"] = "/report-axes";
    Url["ReportFunctions"] = "/report-functions";
    Url["ReportGroups"] = "/report-groups";
    Url["ReportMetrics"] = "/report-metrics";
    Url["ReportingCallWallBoard"] = "/reporting/call-wallboard";
    Url["ReportingCustom"] = "/reporting/custom";
    Url["ReportingHistoric"] = "/reporting-historic";
    Url["ReportingHistoricInteractionsOverTime"] = "/reporting/interactions-over-time";
    Url["ReportingHistoricLanguages"] = "./reporting/interactions-by-language";
    Url["ReportingHistoricUsers"] = "./reporting/interactions-by-user";
    Url["ReportingPublic"] = "/reporting-public";
    Url["ReportingQueue"] = "/reporting-queue";
    Url["Reports"] = "/reports";
    Url["Settings"] = "/settings";
    Url["Setup"] = "/setup";
    Url["Setups"] = "/setups";
    Url["Skills"] = "/skills";
    Url["SocketDetails"] = "/socket-details";
    Url["StartBlocks"] = "/logic/start-blocks";
    Url["SurveyForms"] = "/survey-forms";
    Url["Templates"] = "/text-templates";
    Url["TemplatesUsagesStatistics"] = "/text-templates/usages/statistics";
    Url["TemplatesFeatured"] = "/text-templates/featured";
    Url["TemplatesUsages"] = "/text-templates/:textTemplateId/usages";
    Url["TextLocalisations"] = "/text-localisations";
    Url["TextLocalisationTranslations"] = "/text-localisation-translations";
    Url["TextTranslations"] = "/text-localisations/:textLocalisationId/translations";
    Url["TextTemplateGroups"] = "/text-template-groups";
    Url["TextTemplateVariables"] = "/text-template-variables";
    Url["Themes"] = "/themes";
    Url["Topics"] = "/topics";
    Url["Translations"] = "/translations";
    Url["UserSignOut"] = "/users/:userId/sign-outs";
    Url["Users"] = "/users";
    Url["UsersMe"] = "/users/me";
    Url["UsersMetrics"] = "/users/metrics";
    Url["UserStates"] = "/user-states";
    Url["Variables"] = "/variables";
    Url["ValidateToken"] = "/token";
    Url["ValidateUser"] = "/authenticate";
    Url["Visualisations"] = "/visualisations";
    Url["WrapUpForms"] = "/wrap-up-forms";
    Url["WebsiteSessions"] = "/website-sessions";
    Url["WebsiteSessionInvitations"] = "/website-sessions/:websiteSessionId/invitations";
    Url["WebsiteSessionsRejections"] = "/website-sessions/:websiteSessionId/rejections";
    Url["WebsiteSessionStates"] = "/website-session-states";
    Url["WebsiteSessionVariableStrings"] = "/website-session-variable-strings";
})(Url || (Url = {}));
export default Url;
//# sourceMappingURL=url.js.map